import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
} from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  TextSkeleton,
  DoubleTextSkeleton,
} from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { useGlobalProductContext } from '../../../../../contexts';
import { availableProductFixedIncomeConstant } from '../constants';

export const ListLoadingItemDesktop: React.FC = () => {
  const { product } = useGlobalProductContext();

  const getFlex = (index: number) => {
    const currentHead = availableProductFixedIncomeConstant.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="80px">
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <DetailsSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TextSkeleton hasCaptions />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <DoubleTextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <DoubleTextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <DoubleTextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TextSkeleton />
      </TableContentItemColumn>
    </TableContent>
  );
};
